import { ButtonLink } from "dyl-components";
import { useEffect, useRef, useState } from "react";
import { Grid, Header, Segment } from "semantic-ui-react";
import FundAccountForm from "./FundAccountForm";

import paymentActions from "actions/payment";
import { hostedProfileSettings } from "shared/Payment/hostedProfileSettings";
import { useDispatch, useSelector } from "react-redux";
import { MathUtils, StringUtils } from "utils";
import subscriptionActions from "actions/subscription";
import BulkActionsProvider from "shared/context/BulkActionsProvider";
import { DYL_ACCOUNT_ID } from "shared/modals/QuoteBuilderModal/helper";

import './AccountBalance.scss';

const AccountBalance = () => {
    const [isFundingAccount, setIsFundingAccount] = useState(false);
    const dispatch = useDispatch();
    const customer_id = useSelector(state => state.auth.customer_id);
    const isDYLAccount = Number(customer_id) === DYL_ACCOUNT_ID;
    const payElement = useRef();

    useEffect(() => {
        dispatch(paymentActions.getBalance(customer_id, { isAdmin: true }));
    }, [dispatch, customer_id])

    const onLoadPaymentMethods = async () => {
        await dispatch(paymentActions.resetFormToken());
        return dispatch(paymentActions.getPaymentMethods(customer_id, { isAdmin: true })).then((response) => {
            if (!response.profile.paymentProfiles) {
                dispatch(
                    paymentActions.generateAcceptCustomerFormToken(
                        {
                            hostedProfileSettings: hostedProfileSettings
                        },
                        { isAdmin: true },
                        customer_id
                    )
                ).then(() => {
                    payElement.current?.submit({ target: "add_payment" });
                });
            }
        });
    };

    const onLoadOutstandingInvoices = () => {
        dispatch(subscriptionActions.getOutstandingInvoices(customer_id, { isAdmin: true }));
    }

    const balanceInfo = useSelector(state => (state.payment.balanceInfo));
    const isRetrievingBalance = useSelector(state => (state.payment.isRetrievingBalance));

    return (
        <Segment loading={isRetrievingBalance}>
            <Grid>
                <Grid.Row columns="equal">
                    <Grid.Column>
                        <Header color="primary">Account Balance</Header>
                        <Header {...(balanceInfo.account_balance < 0 ? { className: 'Balance Balance--negative' } : {})} as='h4'>${StringUtils.formatDecimal(`${MathUtils.roundDecimals(balanceInfo.account_balance)}`, true)}</Header>
                    </Grid.Column>
                    <Grid.Column>
                        <Header color="primary">SMS Reload Balance</Header>
                        <Header {...(balanceInfo.sms_balance < 0 ? { className: 'Balance Balance--negative' } : {})} as='h4'>${StringUtils.formatDecimal(`${MathUtils.roundDecimals(balanceInfo.sms_balance)}`, true)}</Header>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <ButtonLink
                            onClick={() => {
                                setIsFundingAccount(true);
                                onLoadPaymentMethods();
                                onLoadOutstandingInvoices();
                            }}
                            noPadding
                            disabled={isDYLAccount}
                        >
                            Fund Account
                        </ButtonLink>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <BulkActionsProvider>
                <FundAccountForm
                    isOpen={isFundingAccount}
                    onClose={() => {
                        setIsFundingAccount(false);
                    }}
                    payElement={payElement}
                />
            </BulkActionsProvider>
        </Segment>
    );
};

export default AccountBalance;
